module.exports = __webpack_public_path__ + "static/img/LK.80f63008.jpg";